// Author THQ
// Date 2025-03-06 15:27:18

import * as model from "@/model/em/ppe/PpeApplyRecordDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PpeApplyRecordDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_PPE_URL,
    })
    .buildStore()
